// @flow
import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import Box from 'sail/Box';
import Group from 'sail/Group';

import {AlignBox} from 'sail/Align';
import Badge from 'sail/Badge';
import {Text, DisplayTextProps} from 'sail/Text';
import {InlineLink} from 'sail/InlineLink';
import {CompactTooltip} from 'sail/Tooltip';

import {Heading, Paragraph} from 'docs/components';
import {IntroCallout} from './IntroCallout';
import './LeftContainer.scss';

const messages = defineMessages({
  guideText: {
    id: 'docsShell.integrationBuilder.guide.guideText',
    description:
      'Callout to read a text-version of the guide with a link to the guide',
    defaultMessage: 'View the text-based guide',
  },
});

type LeftContainerProps = {|
  title: React.Element<typeof Heading>,
  description: Array<React.Element<typeof Paragraph>>,
  textGuideHref: string,
  buttonGroup: ?React.Element<any>,
  children: Array<React.Element<any>>,
|};

export default ({
  title,
  description,
  textGuideHref,
  buttonGroup,
  children,
}: LeftContainerProps) => {
  return (
    <Box className="LeftContainer">
      <Box margin={{horizontal: 32}} className="LeftContainer--introduction">
        <Group direction="horizontal" spacing={12}>
          {title}
          {textGuideHref && (
            <span className="LeftContainer--introduction-icon">
              <AlignBox
                reference={DisplayTextProps}
                style={{display: 'inline-flex'}}
              >
                <InlineLink href={textGuideHref} className="GuideBadge">
                  <CompactTooltip
                    context={
                      <Badge
                        icon="guide"
                        collapsed
                        collapseDirection="right"
                        label={<FormattedMessage {...messages.guideText} />}
                        style={{marginLeft: 0}}
                      />
                    }
                    label={<FormattedMessage {...messages.guideText} />}
                  />
                </InlineLink>
              </AlignBox>
            </span>
          )}
        </Group>
        {buttonGroup}
        <Box margin={{bottom: 32}} className="LeftContainer--description">
          <Text size={16} lineHeight={24}>
            {React.Children.toArray(description)}
          </Text>
          <IntroCallout />
        </Box>
      </Box>
      {children}
    </Box>
  );
};
